
import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { ShopNotification } from 'actions/actionTypes';
import * as actions from 'actions/common/shopNotification';
import * as callActions from 'actions/common/callNotification';

import { callShopNotificationInfo } from 'network/apis/common/shopNotification';

function* loadShopNotificationInfoRequestSaga() {
    try {
        const shopNotification = yield select(state => state.shopNotification);
        
        const response = yield call(callShopNotificationInfo, shopNotification.notification.id);

        yield put(actions.loadShopNotificationInfoRequestSuccess(response.data));
        yield put(callActions.loadCallNotificationInfoRequestSuccess(response.data));
    } catch(error) {
        yield put(actions.loadShopNotificationInfoRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(ShopNotification.LOAD_SHOP_NOTIFICATION_INFO_REQUEST, loadShopNotificationInfoRequestSaga),
    ]);
}